import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ViewCell} from '../../ng2-smart-table/components/cell/cell-view-mode/view-cell';
import { Globals } from "../../../services/globals";
@Component({
  selector: 'app-table-edit-delete',
  template: `
  
    <div ngbDropdown container="body" placement="bottom-right">
      <a ngbDropdownToggle aria-expanded="false" class="table-action" href="javascript:void(0)">
          <i class="fas fa-ellipsis-v"></i>
      </a>
      <ul ngbDropdownMenu class="top-dropdown-menu action-dropdown" aria-labelledby="table-action">
        <li class="dropdown-item d-flex align-items-center" style="justify-content: space-between;" (click)="onEditClick()">
          <a href="javascript:void(0);"  id="lnkEdit" class="text-link no-underline"> 
              Edit
          </a>
          <span><i class="icon icon-edit mr-3" style="color: #6F6F8D"></i></span>
        </li>
        <li class="dropdown-item d-flex align-items-center" style="justify-content: space-between;" (click)="onTrashClick()">
          <a href="javascript:void(0);" id="lnkDelete" class="text-link no-underline "> 
              Delete
          </a>
          <span><i class="nxticon-delete-new nxt-font-20" style="margin-left: -3px; color: #6F6F8D;
          margin-right: 8px;
          margin-bottom: 4px;"></i></span>
        </li>
      </ul>
    </div>
  `,
  styles: []
})
export class TableEditDeleteComponent implements ViewCell, OnInit {

  renderValue: boolean;
  deleteIcon = '';

  @Input() value: string | number;
  @Input() rowData: any;

  @Output() editClick: EventEmitter<any> = new EventEmitter();
  @Output() deleteClick: EventEmitter<any> = new EventEmitter();
  
  constructor( private globals: Globals ) {
    this.deleteIcon = this.globals.getTableDeleteIcon( );
  }

  ngOnInit() {
    this.renderValue = !!this.value;
    // console.log('=============>' + this.rowData.client_type);
  }


  onEditClick() {
    this.editClick.emit(this.rowData);
  }

  onTrashClick() {
    console.log(this.rowData);
    this.deleteClick.emit(this.rowData);
  }
}
